export const globalStatisticsKeys = {
  all: ["statistics"] as const,
};
